const breakPoints = {
  minDesktop: '1024',
  maxTablet: '1023',
  minTablet: '768',
  maxMobile: '767',
}

const stage = {
  preLive: 0,
  live: 1,
  postLive: 2,
  history: 3,
}

const recallPossibleResults = {
  yes: 'yes',
  no: 'no',
}

const cecDataMode = {
  devRunning: 'devRunning',
  devFinal: 'devFinal',
  prodRunning: 'prodRunning',
  prodFinal: 'prodFinal',
}

const types = {
  text: 'TEXT',
  image: 'IMAGE',
  furtherLink: 'FURTHERLINK',
  embeddedVideo: 'EMBEDDEDVIDEO',
  embeddedPost: 'EMBEDDEDPOST',
  video: 'VIDEO',
  quote: 'QUOTE',
  time: 'TIME'
};

const sectionIds = {
  takeAway: 'anchor-recall-takeaway',
  graphic: 'anchor-recall-graphic',
  more: 'anchor-more',
}

const setup = {
  cdnUrlBase: 'https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu',
  maxNumberOfEvents: 5,
  originDev: 'http://localhost:3000',
  originProd: 'https://hanrecall.pts.org.tw',
  updateInterval: `${60}000`,
  currentStage: stage.history,
  recallResult: recallPossibleResults.yes,
  numberOfElector: 100,
  maxContentWidth: '1000px',
  cecDataMode: cecDataMode.prodFinal,
  votingEligiblePopulation: 2299981,
  enablePLive: true,
  pLiveHref: 'https://youtu.be/M506IOmAkrU',
}

export {
  breakPoints,
  setup,
  types,
  stage,
  sectionIds,
  recallPossibleResults,
};
